import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import Geometry from "ol/geom/Geometry";
import VectorLayer from "ol/layer/Vector";
import { BackupRecord, CoordinateNotation, MapView, ProjectIdHistory } from './models/AbacoMap';
import { LayerSettings, LegendLayer, LocalGeoRaster, Theme } from "./models/Layer";
import { Council, Parcel, ParcelDetail, Province, Region, Sheet } from "./models/Parcels";

export default class MapVuexModule extends AbacoVuexModule {
    @State() globalMapView!: MapView | null;
    @State({ default: 0 }) prjId!: number;
    @State({default: []}) prjIdHistory!: ProjectIdHistory[];

    @State() farmLayers!: any | null;
    @State({ default: {} as LayerSettings }) layerSettings!: { [key: string]: LayerSettings | undefined }
    @State() curGeometry!: Geometry | null;
    @State() geoRastersSelectedData!: LocalGeoRaster[];
    @State({default: {}}) bckLayers!: BackupRecord;
    @State({default: "dms-notation"}) curCoordinateNotation!: CoordinateNotation;
    @State({default: false}) invalidatePlotCache!: boolean;
    @State({default: {}}) overlayVectorLayers!: Record<number, string[]>;
    @State({default: {}}) curBackgroundPriority!: Record<number, number>;
    @State({default: 0}) themeChanged!: number;

    @State({default: []}) cadastralParcels!: ParcelDetail[];
    @State({default: null}) cadastralServicesToken!: string | null;

    @State({default: null}) cadastralFormCurRegion!: Region | null;
    @State({default: []}) cadastralFormProvinces!: Province[];
    @State({default: null}) cadastralFormCurProvince!: Province | null;
    @State({default: []}) cadastralFormCouncils!: Council[];
    @State({default: null}) cadastralFormCurCouncil!: Council | null;
    @State({default: []}) cadastralFormSheets!: Sheet[];
    @State({default: null}) cadastralFormCurSheet!: Sheet | null;
    @State({default: []}) cadastralFormParcels!: Parcel[];
    @State({default: null}) cadastralFormCurParcel!: Parcel | null;
    @State({ default: false }) isPlotsOptimizationActive!: boolean;

}
